import React from 'react'
import styles from './style.module.scss'

const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.inner}>
      <div className="row">
        <div className="col-lg-9">
          <p>
            <strong>Wiz365 | The Best Virtual Event Platform you&#39;ll ever need!</strong>
          </p>
          <p>
            Wiz365 is an intuitive and amazingly designed platform. It&#39;s feature rich and extremly robust.
          </p>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className="row">
          <div className="col-sm-6" />
          <div className="col-sm-6">
            <div className={styles.copyright}>
              <img
                src="resources/images/wiztales.png"
                rel="noopener noreferrer"
                alt="WizTales Media Pvt. Ltd."
              />
              <span>
                © 2020{' '}
                <a href="http://wiztales.com" target="_blank" rel="noopener noreferrer">
                  WizTales Media Pvt. Ltd.
                </a>
                <br />
                All rights reserved
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Footer
